import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultEpisode = {
  pub_date: new Date(),
  is_published: true,
  is_premium: false,
  tag_ids: [],
  collection_ids: [],
  _embedded: {
    artwork: {
      file: {},
    },
    audio: {},
    video: {
      video_id: '',
      service: 'youtube',
    },
  },
};

// const saveRelated = params =>
//   Promise.resolve()
//     .then(() => {
//       if (params.replace_artwork) {
//         return HTTP.post('/media/images', { file: params.artwork });
//       }
//       return Promise.resolve(null);
//     });

export default {
  actions: {
    async [actions.DO_CREATE_EPISODE]({ commit }, params) {
      // return saveRelated(params)
      //   .then((response) => {
      //     if (response !== null) {
      //       params.artwork_id = response.data.data.images[0].id;
      //     }
      //     return HTTP.post('/episodes', params);
      //   });
      const { data } = await HTTP.post('/episodes', params);
      return data;
    },
    async [actions.DO_DELETE_EPISODE]({ commit }, params) {
      const { data } = await HTTP.delete(`/episodes/${params.id}`, params);
      return data;
    },
    async [actions.DO_GET_EPISODE]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/episodes/${id}`, { params });
      commit(mutations.SET_EPISODE, data.data.episodes[0]);
      return data;
    },
    async [actions.DO_GET_EPISODES]({ commit }, params) {
      const { data } = await HTTP.get('/episodes', params);
      commit(mutations.SET_EPISODES, data.data.episodes);
      return data;
    },
    async [actions.DO_SEARCH_EPISODES]({ commit }, payload) {
      const { data } = await SEARCH.post('/doxa_episodes/episode/_search', payload);
      const episodes = data.hits.hits.map(h => h._source);
      commit(mutations.SET_EPISODES, episodes);
      return data;
    },
    async [actions.DO_UPDATE_EPISODE]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.put(`/episodes/${id}`, params);
      return data;
    },
  },
  getters: {
    [getters.GET_EPISODE]: state => state.episode,
    [getters.GET_EPISODE_FILTERS]: state => state.filters,
    [getters.GET_EPISODES]: state => state.episodes,
  },
  mutations: {
    [mutations.SET_EPISODE](state, episode) {
      if (episode.pub_date !== undefined) {
        episode.pub_date = moment(episode.pub_date).toDate();
      }
      state.episode = episode;
    },
    [mutations.SET_EPISODE_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.episode;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_EPISODE_FILTER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.filters;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_EPISODES](state, episodes) {
      state.episodes = episodes;
    },
    [mutations.SET_EPISODE_TAG_AT_INDEX](state, field) {
      Vue.set(state.episode.tag_ids, field.index, field.val);
    },
    [mutations.SET_EPISODE_COLLECTION_AT_INDEX](state, field) {
      Vue.set(state.episode.collection_ids, field.index, field.val);
    },
    [mutations.UNSET_EPISODE](state) {
      state.episode = _.cloneDeep(defaultEpisode);
    },
    [mutations.UPDATE_EPISODE_FIELD](state, { field, value }) {
      Object.assign(state.episode, {
        [field]: value,
      });
    },
  },
  state: {
    episodes: [],
    episode: _.cloneDeep(defaultEpisode),
    filters: {
      sort: {
        field: 'pub_date',
        order: 'desc',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/episode.js